import { render, staticRenderFns } from "./CompanyBrands.vue?vue&type=template&id=c26091f4"
import script from "./CompanyBrands.vue?vue&type=script&lang=js"
export * from "./CompanyBrands.vue?vue&type=script&lang=js"
import style0 from "./CompanyBrands.vue?vue&type=style&index=0&id=c26091f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports